module.exports = __webpack_public_path__ + "static/img/empty.b1b787d2.png";